// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".showRightPanel{overflow:hidden;position:relative;width:calc(100% - 15px)}", ""]);
// Exports
module.exports = exports;
